import { put, call } from 'redux-saga/effects';
import Bowser from 'bowser';
import { AuthTypes } from '../ducks/auth';
import { checkBrowserCookiesAllowed } from '../../utils/handleCookies';

import { sendNotificationError } from '../../services/logError';

export function sagaSimulateError(message) {
  throw new Error(`sagaSimulateError: ${message}`);
}

export function* sagaErrorHandle({
  sagaName = '',
  errorData,
  checkValidAuthentication = true,
  additionalInfos = null,
}) {
  const error = {
    status: null,
    message: '',
  };
  const apiError = errorData?.response;
  if (apiError) {
    error.status = apiError.status;
    error.message = apiError.data.message;
  }
  yield put({
    type: 'ERROR_HANDLER',
    data: {
      errorData,
      sagaName,
      additionalInfos,
    },
    checkValidAuthentication,
  });
  return error;
}

export function* sagasErrorInterceptor(error, checkValidAuthentication) {
  const apiError = error?.data?.errorData?.isAxiosError;

  const clientEnvDetails = Bowser.parse(window.navigator.userAgent);
  const cookiesAllowed = checkBrowserCookiesAllowed();

  if (process.env.NODE_ENV === 'development') {
    console.error('sagasErrorInterceptor', error.data.sagaName, error);
    console.info('browser infos --->', clientEnvDetails);
    console.info('browser cookiesAllowed --->', cookiesAllowed);
    console.info('additional infos --->', error.data.additionalInfos);
  }

  if (apiError) {
    if (
      checkValidAuthentication &&
      error.data.errorData.response.status === 401
    ) {
      yield put({ type: AuthTypes.LOGOUT });
    }
  } else {
    const { errorData, sagaName, additionalInfos } = error.data;
    const message = errorData?.message;
    if (process.env.REACT_APP_LOG_ERRORS) {
      yield call(sendNotificationError, {
        message: `${sagaName} ----> ${message || errorData}`,
        details: JSON.stringify({
          browserInfos: clientEnvDetails,
          cookiesAllowed,
          additionalInfos,
        }),
      });
    }
  }
}
